import { createStyles } from 'antd-style';

const useStyles = createStyles(() => {
  return {
    'row-container--card': {
      'display': 'flex',
      'width': '100%',
      '@media (max-width: 1100px)': {
        flexDirection: 'column',
      },
    },
    'card-form-item': {
      'flex': '1',
      'flexBasis': '300px',

      '@media (max-width: 1100px)': {
        flex: 1,
        flexBasis: 'auto',
      },
    },
    'rowContainer': {
      'display': 'flex',
      'flexDirection': 'row',
      'margin': '30px 0',

      '@media (max-width: 1024px)': {
        flexDirection: 'column',
      },
    },
    'rowContainerTense': {
      'display': 'flex',
      'flexDirection': 'row',
      'margin': '30px 0',

      '@media (max-width: 1300px)': {
        flexDirection: 'column',
      },
    },
    'rowContainerSelect': {
      margin: '30px 0',
    },
    'rowContainerSelect.ant-form-item': {
      marginBottom: '0',
    },
    'select-client-item': {
      width: '375px',
    },
    'diagnosis--tag': {
      whiteSpace: 'pre-wrap',
      padding: '5px',
    },
  };
});
export default useStyles;
